import DocumentStatusIcon from './document-status-icon';

export default DocumentStatusIcon;
